import React from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';

import LateralMenu from '../components/LateralMenu';
import Container from '../components/Container';
import Link from '../components/Link';

import Users from '../screens/admin/Users';
import Apps from '../screens/admin/Apps';
import AppsForm from '../screens/admin/AppsForm';

function AdminNavigation() {
  const location = useLocation();
  const { pathname } = location;

  return (
    <div className="navigation-admin-navigation">
      <div>
        <LateralMenu>
          <Link to="/store/admin" active={pathname === '/store/admin'}>
            Dashboard
          </Link>
          <Link to="/store/admin/apps" active={pathname.match(/\/store\/admin\/apps/)}>
            Aplicaciones
          </Link>
          <Link to="/store/admin/usuarios" active={pathname === '/store/admin/usuarios'}>
            Usuarios
          </Link>
        </LateralMenu>
        {
          pathname === '/store/admin' ? (
            <Container bgColor="light" className="dashboard-container">
              ok
            </Container>
          ) : null
        }
      </div>
      <Switch>
        {/*User*/}
        <Route path="/store/admin/usuarios">
          <Users />
        </Route>

        {/* Apps */}
        <Route path="/store/admin/apps/agregar">
          <AppsForm />
        </Route>
        <Route path="/store/admin/apps">
          <Apps />
        </Route>
      </Switch>
    </div>
  );
}

export default AdminNavigation;
